<template>
  <li :class="[chatClasses, { '--agent': !isHunter, '--hunter': isHunter }]">
    <slot />
    <ChatAvatar v-if="hasAvatar" :is-hunter="isHunter" />
  </li>
</template>

<script>
import ChatAvatar from '@/components/chat/ChatAvatar.vue'
import ChatItemPropsMixins from '@/components/chat/ChatItemPropsMixins.js'

export default {
  name: 'ChatItem',
  mixins: [ChatItemPropsMixins],
  components: { ChatAvatar },
  props: {
    isHunter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasAvatar: false,
    }
  },
  computed: {
    chatClasses() {
      return {
        '--first': this.first,
        '--last': this.last,
      }
    },
  },
  mounted() {
    if (this.last) {
      if (this.isHunter) this.hasAvatar = true
      else setTimeout(() => (this.hasAvatar = true), 1000)
    }
  },
}
</script>
